import { BufferGeometry } from 'three';

class UVHelpers {
  static autoUV(object: { geometry: BufferGeometry }) {
    const pos = object.geometry.getAttribute('position');
    const nor = object.geometry.getAttribute('normal');
    const uvs = object.geometry.getAttribute('uv');

    for (let i = 0; i < pos.count; i++) {
      let x = 0, y = 0;

      const nx = Math.abs(nor.getX(i));
      const ny = Math.abs(nor.getY(i));
      const nz = Math.abs(nor.getZ(i));

      // if facing X
      if (nx >= ny && nx >= nz) {
        x = pos.getZ(i);
        y = pos.getY(i);
      }

      // if facing Y
      if (ny >= nx && ny >= nz) {
        x = pos.getX(i);
        y = pos.getZ(i);
      }

      // if facing Z
      if (nz >= nx && nz >= ny) {
        x = pos.getX(i);
        y = pos.getY(i);
      }

      uvs.setXY(i, x, y);
    }

    uvs.needsUpdate = true;  // Mark the attribute as needing an update
  }
}

export default UVHelpers;